import {
  Alert,
  Button,
  Checkbox,
  CloseButton,
  Grid,
  Heading,
  Modal,
  ScreenReaderContent,
  Spinner,
  Text,
  TextInput,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
// import { useState } from "react";

const QualitySettingsModal = ({
  openModal,
  handleClose,
  qcConfig,
  setQcConfig,
  handleSave,
  loadingSaveSettings,
  // selectHandler,
  // id,
  error,
  // interaction,
}) => {
  const { t } = useTranslation();
  // const [variantDescription, setVariantDescription] = useState({
  //   description: t("analyze.variantDescription"),
  //   mode: "view",
  // });

  // const handleChangeMode = (mode) => {
  //   setVariantDescription((prev) => ({ ...prev, mode: mode }));
  // };

  // const renderEditIcon = (props, message) => {
  //   props.label = message;
  //   return InPlaceEdit.renderDefaultEditButton(props);
  // };

  return (
    <Modal
      open={openModal}
      onDismiss={handleClose}
      size="large"
      label={t("analyze.editQualitySettings")}
    >
      <Modal.Header>
        <Grid hAlign="space-between" vAlign="middle">
          <Grid.Row>
            <Grid.Col>
              <Heading level="h2" as="h1">
                {t("analyze.qualitySettingHeader")}
              </Heading>
            </Grid.Col>
            <Grid.Col width="auto">
              <CloseButton
                size="small"
                screenReaderLabel={t("global.close")}
                onClick={handleClose}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </Modal.Header>
      <Modal.Body>
        <Grid vAlign="middle">
          {error && (
            <Alert variant="warning">{t("analyze.positiveIntegerError")}</Alert>
          )}
          <Grid.Row>
            <Grid.Col width={12}>
              <Heading level="h3" as="h2" margin="0 0 small 0">
                {t("analyze.qualitySettingTitle")}
              </Heading>
              <Text>{t("analyze.qualityLengthDescription")}</Text>
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col>
              <Grid>
                <Grid.Row>
                  <Grid.Col>
                    <Heading level="h4" as="h3">
                      {t("analyze.headingTitle")}
                    </Heading>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col width="auto">
                    <span style={{ marginRight: 10 }}>{t("analyze.min")}</span>
                    <TextInput
                      renderLabel={
                        <ScreenReaderContent>
                          {t("analyze.titleScreenReaderMin")}
                        </ScreenReaderContent>
                      }
                      display="inline-block"
                      width="4rem"
                      size="small"
                      value={qcConfig ? qcConfig.titleMin.toString() : ""}
                      onChange={(e) =>
                        setQcConfig({
                          ...qcConfig,
                          titleMin: e.currentTarget.value,
                        })
                      }
                    />
                  </Grid.Col>
                  <Grid.Col width="auto">
                    <span style={{ marginRight: 10 }}>{t("analyze.max")}</span>
                    <TextInput
                      renderLabel={
                        <ScreenReaderContent>
                          {t("analyze.titleScreenReaderMax")}
                        </ScreenReaderContent>
                      }
                      display="inline-block"
                      width="4rem"
                      size="small"
                      value={qcConfig ? qcConfig.titleMax.toString() : ""}
                      onChange={(e) =>
                        setQcConfig({
                          ...qcConfig,
                          titleMax: e.currentTarget.value,
                        })
                      }
                    />
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            </Grid.Col>
            <Grid.Col>
              <Grid>
                <Grid.Row>
                  <Grid.Col>
                    <Heading level="h4" as="h3">
                      {t("analyze.headingDescription")}
                    </Heading>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col width="auto">
                    <span style={{ marginRight: 10 }}>{t("analyze.min")}</span>
                    <TextInput
                      renderLabel={
                        <ScreenReaderContent>
                          {t("analyze.decriptionReaderMin")}
                        </ScreenReaderContent>
                      }
                      display="inline-block"
                      width="4rem"
                      size="small"
                      value={qcConfig ? qcConfig.descriptionMin.toString() : ""}
                      onChange={(e) =>
                        setQcConfig({
                          ...qcConfig,
                          descriptionMin: e.currentTarget.value,
                        })
                      }
                    />
                  </Grid.Col>
                  <Grid.Col width="auto">
                    <span style={{ marginRight: 10 }}>{t("analyze.max")}</span>
                    <TextInput
                      renderLabel={
                        <ScreenReaderContent>
                          {t("analyze.decriptionReaderMax")}
                        </ScreenReaderContent>
                      }
                      display="inline-block"
                      width="4rem"
                      size="small"
                      value={qcConfig ? qcConfig.descriptionMax.toString() : ""}
                      onChange={(e) =>
                        setQcConfig({
                          ...qcConfig,
                          descriptionMax: e.currentTarget.value,
                        })
                      }
                    />
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col>
              <Heading level="h3" as="h2">
                {t("analyze.taxonomyTitle")}
              </Heading>
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col>
              <ul style={{ listStyle: "none" }}>
                <li style={{ marginBottom: 25 }}>
                  <Checkbox
                    label={t("analyze.noPolicy")}
                    value="none"
                    checked={qcConfig.noPolicyChecked}
                    onChange={() =>
                      setQcConfig({
                        ...qcConfig,
                        noPolicyChecked: !qcConfig.noPolicyChecked,
                        atLeastChecked: false,
                        maxChecked: false,
                        leastNumVerbs: "",
                        maxNumVerbs: "",
                      })
                    }
                  />
                </li>
                <li style={{ marginBottom: 25 }}>
                  <Checkbox
                    checked={qcConfig.atLeastChecked}
                    onChange={() =>
                      setQcConfig({
                        ...qcConfig,
                        atLeastChecked: !qcConfig.atLeastChecked,
                        noPolicyChecked: false,
                      })
                    }
                    label={
                      <>
                        {t("analyze.atLeast")}{" "}
                        <TextInput
                          renderLabel={
                            <ScreenReaderContent>
                              {t("analyze.taxonomyReader")}
                            </ScreenReaderContent>
                          }
                          display="inline-block"
                          interaction={
                            qcConfig.atLeastChecked ? "enabled" : "disabled"
                          }
                          width="3rem"
                          size="small"
                          value={
                            qcConfig.noPolicyChecked
                              ? ""
                              : qcConfig
                                ? qcConfig.leastNumVerbs.toString()
                                : ""
                          }
                          onChange={(e) =>
                            setQcConfig({
                              ...qcConfig,
                              leastNumVerbs: e.currentTarget.value,
                            })
                          }
                        />{" "}
                        {t("analyze.taxonomyLevels")}
                      </>
                    }
                  />
                </li>
                <li style={{ marginBottom: 25 }}>
                  <Checkbox
                    checked={qcConfig.maxChecked}
                    onChange={() =>
                      setQcConfig({
                        ...qcConfig,
                        maxChecked: !qcConfig.maxChecked,
                        noPolicyChecked: false,
                      })
                    }
                    label={
                      <>
                        {t("analyze.noMoreThan")}{" "}
                        <TextInput
                          renderLabel={
                            <ScreenReaderContent>
                              {t("analyze.taxonomyReaderMax")}
                            </ScreenReaderContent>
                          }
                          interaction={
                            qcConfig.maxChecked ? "enabled" : "disabled"
                          }
                          display="inline-block"
                          width="3rem"
                          size="small"
                          value={
                            qcConfig.noPolicyChecked
                              ? ""
                              : qcConfig
                                ? qcConfig.maxNumVerbs.toString()
                                : ""
                          }
                          onChange={(e) =>
                            setQcConfig({
                              ...qcConfig,
                              maxNumVerbs: e.currentTarget.value,
                            })
                          }
                        />{" "}
                        {t("analyze.taxonomyLevels")}
                      </>
                    }
                  />
                </li>
              </ul>
            </Grid.Col>
          </Grid.Row>
          {/* disabling for now as it currently has no effect on fetch/processing workflow. Version/Variation step currently disabled */}
          {/* 
      <Grid.Row>
        <Grid.Col>
          <Heading level="h3" as="h2">
            {t("analyze.variantTitle")}
          </Heading>
          <View as="div">
            <InPlaceEdit
              renderViewer={() => (
                <div style={{ margin: "10px 0" }}>
                  <Text>
                    {qcConfig.description || variantDescription["description"]}
                  </Text>
                </div>
              )}
              renderEditor={(props) => (
                <Text
                  as="input"
                  type="text"
                  value={
                    qcConfig.description
                      ? qcConfig.description
                      : variantDescription["description"]
                  }
                  onChange={(e) => {
                    variantDescription["description"] = e.target.value;
                    setVariantDescription({ ...variantDescription });
                    setQcConfig({
                      ...qcConfig,
                      description: variantDescription["description"],
                    });
                  }}
                  onBlur={props.onBlur}
                  elementRef={props.editorRef}
                />
              )}
              renderEditButton={(props) => renderEditIcon(props, "test")}
              onChangeMode={(mode) => handleChangeMode(mode)}
              mode={
                variantDescription["mode"] ? variantDescription["mode"] : "view"
              }
              value={variantDescription["description"]}
              inline={false}
            />
          </View>
        </Grid.Col>
      </Grid.Row> */}
          {/* <Grid.Row>
        <Grid.Col>
          <Checkbox
            label={t("analyze.noPolicy")}
            value="none"
            checked={qcConfig.noVariantPolicyChecked}
            onChange={() =>
              setQcConfig({
                ...qcConfig,
                noVariantPolicyChecked: !qcConfig.noVariantPolicyChecked,
                percentDifference: "",
              })
            }
          />
        </Grid.Col>
      </Grid.Row>
      <Grid.Row>
        <Grid.Col>
          <Heading level="h4" as="h3">
            {t("analyze.percentDifference")}
          </Heading>
        </Grid.Col>
      </Grid.Row>

      <Grid.Row>
        <Grid.Col width="auto">
          <span style={{ marginRight: 10 }}>
            {t("analyze.percentDifferenceDescription")}{" "}
          </span>
          <TextInput
            renderLabel={
              <ScreenReaderContent>
                {t("analyze.variantReader")}
              </ScreenReaderContent>
            }
            interaction={
              qcConfig.noVariantPolicyChecked ? "disabled" : "enabled"
            }
            display="inline-block"
            width="4rem"
            size="small"
            value={
              qcConfig.noVariantPolicyChecked
                ? ""
                : qcConfig
                ? qcConfig.percentDifference.toString()
                : ""
            }
            onChange={(e) =>
              setQcConfig({
                ...qcConfig,
                percentDifference: e.currentTarget.value,
              })
            }
          />
          <span style={{ marginRight: 10 }}>{t("analyze.variantInput")} </span>
        </Grid.Col>
      </Grid.Row> */}
          {/* <Grid.Row>
        <Grid.Col width="auto">
          <span style={{ marginRight: 10 }}>
            {t("analyze.variantDropDown")}
          </span>
        </Grid.Col>
        <Grid.Col>
          <ComparisonSelect
            id={id}
            selectHandler={selectHandler}
            interaction={interaction}
          />
        </Grid.Col>
      </Grid.Row> */}
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <Button margin="0 small 0 0" onClick={handleClose}>
          {t("global.cancel")}
        </Button>
        <Button
          color="primary"
          type="submit"
          onClick={handleSave}
          disabled={loadingSaveSettings}
        >
          {loadingSaveSettings ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            t("global.save")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QualitySettingsModal;
